import type { Feature } from '@luna/gatekeeper';

export const creditCardStatements: Feature = {
    enabled: true,
    _description:
        'Displays credit card statements menu item and statements page - supported by all countries except AT',
};
